module.exports = __webpack_public_path__ + "static/media/keyrings.949c1ba2.png";